import React, { useState } from 'react';
import UserManagement from './users/UserManagement';
import GroupManagement from './groups/GroupManagement';
import './ManagementDashboard.css';

const ManagementDashboard = () => {
  const [activeTab, setActiveTab] = useState('users');

  const tabs = [
    {
      id: 'users',
      label: 'Users',
      icon: '👤',
      component: UserManagement
    },
    {
      id: 'groups',
      label: 'Groups',
      icon: '👥',
      component: GroupManagement
    }
  ];

  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="management-dashboard">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>User & Group Management</h1>
          <p className="header-description">
            Comprehensive management system for FreeIPA users and groups
          </p>
        </div>
      </div>

      <div className="dashboard-tabs">
        <div className="tab-navigation">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>

        <div className="tab-content">
          {ActiveComponent && <ActiveComponent />}
        </div>
      </div>
    </div>
  );
};

export default ManagementDashboard;
